import { render } from "./NavigationBar.vue?vue&type=template&id=c047672a&scoped=true"
import script from "./NavigationBar.vue?vue&type=script&lang=js"
export * from "./NavigationBar.vue?vue&type=script&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=c047672a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c047672a"]])

export default __exports__